module.exports = __webpack_public_path__ + "static/media/garantia.c7923460.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/comparative/aeropost/garantia.png
// module id = 1202
// module chunks = 0